
import { Vue, Component, Prop } from 'vue-property-decorator'
  @Component
export default class DeleteOccupy extends Vue {
    @Prop() dialogDeleteZy: boolean

    // 删除占用弹窗关闭
    handleZyClose() {
      this.$emit('delete-occupy', 'close')
    }
    // 删除占用弹窗确定
    handleZyTrue() {
      this.$emit('delete-occupy', 'true')
    }
}
